import type { APHandle } from '~/modules/root';

/**
 * Route handle shared by the Spaces and Styles views. Mirrors /projects' revamp
 * branch: the dark editorial browse theme needs the unified header's near-black
 * bar, which the loader opts into via `pageTheme: 'transparent'`.
 */
export const imageLabelBrowseHandle: APHandle = {
    isCategoryPage: true,
    showStickyNavAfterPosition: 500,
    hideContactArchiPro: false,
    header: (loaderData) =>
        (loaderData as { pageTheme?: string } | undefined)?.pageTheme ===
        'transparent'
            ? { showLogomark: true, solidTheme: 'dark' }
            : { showLogomark: true },
};
